export interface TickerItem {
  time: string;
  level: "高风险" | "中风险" | "关注";
  text: string;
}

export const navItems = [
  { key: "risk-flash", label: "风险速报" },
  { key: "endorse-rank", label: "代言指数" },
  { key: "case-grid", label: "合作避雷" },
  { key: "termination", label: "解约动态" },
  { key: "crisis", label: "公关危机" },
  { key: "method", label: "监控说明" },
];

export const hotTags = [
  "代言翻车",
  "提前解约",
  "公关道歉",
  "私德争议",
  "税务通报",
  "合同违约",
  "品牌切割",
  "商业价值缩水",
  "舆情预警",
  "合作避雷",
];

export const headlineStats = [
  { label: "今日新增风险线索", value: "128", unit: "条", trend: "+12" },
  { label: "在监代言合作", value: "2,431", unit: "项", trend: "+37" },
  { label: "本周解约/切割", value: "19", unit: "起", trend: "+4" },
  { label: "高风险待排查", value: "46", unit: "个", trend: "-6" },
];

export const riskIndex = {
  score: 72,
  level: "偏高",
  delta: "+5.4",
  updated: "2026-09-12 09:40",
};

export const tickerItems: TickerItem[] = [
  { time: "09:38", level: "高风险", text: "某头部饮品品牌撤下联名物料，代言合作进入观察期" },
  { time: "09:12", level: "中风险", text: "某综艺常驻嘉宾旧言论被翻出，两条商业合作被指暂缓官宣" },
  { time: "08:47", level: "关注", text: "某美妆集团更新代言人矩阵，涉及三名艺人物料同步下线" },
  { time: "08:20", level: "高风险", text: "税务传闻再起，某男团成员两档综艺宣发被临时调整" },
  { time: "07:55", level: "中风险", text: "直播带货口播争议发酵，合作品牌客服咨询量翻倍" },
  { time: "07:31", level: "关注", text: "某运动品牌删除节日宣传图，评论区舆情热度上升" },
  { time: "06:58", level: "中风险", text: "私德争议话题冲上热榜，两家品牌被网友点名要求表态" },
  { time: "06:20", level: "关注", text: "行业自律名单更新，多家甲方启动代言人背景复核" },
];

export interface RankItem {
  rank: number;
  name: string;
  category: string;
  heat: number;
  riskScore: number;
  trend: "up" | "down" | "flat";
  trendValue: string;
  tags: string[];
  note: string;
}

export const rankingItems: RankItem[] = [
  {
    rank: 1,
    name: "某流行男歌手",
    category: "音乐 / 综艺",
    heat: 98,
    riskScore: 88,
    trend: "up",
    trendValue: "+21",
    tags: ["税务传闻", "物料下线"],
    note: "近 48 小时讨论量激增，已有两家品牌暂停相关投放。",
  },
  {
    rank: 2,
    name: "某影视女演员",
    category: "影视 / 时尚",
    heat: 91,
    riskScore: 79,
    trend: "up",
    trendValue: "+14",
    tags: ["旧言论", "合作暂缓"],
    note: "代言合约临近续签节点，舆情波动直接关联商业价值评估。",
  },
  {
    rank: 3,
    name: "某综艺常驻主持",
    category: "综艺 / 主持",
    heat: 85,
    riskScore: 74,
    trend: "flat",
    trendValue: "+2",
    tags: ["口播争议"],
    note: "争议集中在直播切片，品牌方客服侧压力上升。",
  },
  {
    rank: 4,
    name: "某男子演唱组合",
    category: "音乐 / 演出",
    heat: 78,
    riskScore: 61,
    trend: "down",
    trendValue: "-9",
    tags: ["私德争议"],
    note: "团队已发布说明，热度小幅回落但仍高于日常基准。",
  },
  {
    rank: 5,
    name: "某运动项目运动员",
    category: "体育 / 赛事",
    heat: 71,
    riskScore: 55,
    trend: "up",
    trendValue: "+7",
    tags: ["赛外话题"],
    note: "赛外话题带动曝光，暂未见品牌层面的明显动作。",
  },
  {
    rank: 6,
    name: "某网络剧主演",
    category: "影视 / 短剧",
    heat: 64,
    riskScore: 48,
    trend: "flat",
    trendValue: "+1",
    tags: ["剧情争议"],
    note: "话题以剧集内容为主，商业合作暂未受影响。",
  },
  {
    rank: 7,
    name: "某美妆类达人",
    category: "达人 / 直播",
    heat: 58,
    riskScore: 42,
    trend: "down",
    trendValue: "-5",
    tags: ["选品质疑"],
    note: "历史选品问题被集中讨论，合作品牌已启用备用预案。",
  },
];

export interface CaseStudy {
  id: string;
  size: "large" | "medium" | "small";
  category: string;
  brand: string;
  title: string;
  summary: string;
  metrics: { label: string; value: string }[];
  image: string;
  level: "高风险" | "中风险" | "关注";
}

export const caseStudies: CaseStudy[] = [
  {
    id: "case-001",
    size: "large",
    category: "代言翻车",
    brand: "某运动品牌",
    title: "官宣当日舆情反转：一场被紧急叫停的联名官宣",
    summary:
      "联名物料原定上午十点全渠道上线，官宣前两小时代言人相关旧内容被集中翻出。品牌方在评估热搜走向与经销商反馈后，选择延后发布并撤下预售页面，同时启动合约条款中的舆情条款沟通。",
    metrics: [
      { label: "舆情峰值", value: "3.2 万条/时" },
      { label: "物料撤回", value: "6 个渠道" },
      { label: "观察周期", value: "14 天" },
    ],
    image:
      "https://readdy.ai/api/search-image?query=editorial%20business%20risk%20monitoring%20concept%20of%20a%20canceled%20brand%20campaign%2C%20rolled%20up%20banner%20and%20folded%20contract%20on%20a%20cream%20paper%20desk%2C%20deep%20crimson%20and%20warm%20amber%20accents%2C%20minimal%20studio%20light%2C%20abstract%20geometric%20composition%2C%20high%20detail&width=1200&height=800&seq=case-big-001&orientation=landscape",
    level: "高风险",
  },
  {
    id: "case-002",
    size: "medium",
    category: "合作避雷",
    brand: "某饮品集团",
    title: "续约前的背景复核，如何提前两周围猎风险",
    summary:
      "在年度代言续约窗口前，团队将公开言论、历史合作履约与关联方信息纳入复核清单，提前识别出两处需要留意的信号。",
    metrics: [
      { label: "复核维度", value: "18 项" },
      { label: "提前预警", value: "14 天" },
    ],
    image:
      "https://readdy.ai/api/search-image?query=editorial%20concept%20of%20a%20brand%20due%20diligence%20checklist%20on%20a%20cream%20desk%20with%20magnifier%20and%20folders%2C%20deep%20crimson%20and%20warm%20amber%20tones%2C%20minimal%20studio%20lighting%2C%20clean%20abstract%20geometric%20layout%2C%20high%20detail&width=900&height=700&seq=case-med-002&orientation=landscape",
    level: "中风险",
  },
  {
    id: "case-003",
    size: "medium",
    category: "公关危机",
    brand: "某美妆集团",
    title: "一场道歉声明后的品牌侧复盘清单",
    summary:
      "从声明节奏、口径统一到渠道物料更新，危机响应被拆解为可复用的复盘清单，用于后续合作风险评估。",
    metrics: [
      { label: "响应时长", value: "5 小时" },
      { label: "涉及渠道", value: "11 个" },
    ],
    image:
      "https://readdy.ai/api/search-image?query=editorial%20PR%20crisis%20review%20concept%20with%20microphone%20and%20press%20folder%20on%20a%20cream%20table%2C%20deep%20crimson%20and%20warm%20amber%20accents%2C%20minimal%20studio%20light%2C%20abstract%20clean%20composition%2C%20high%20detail&width=900&height=700&seq=case-med-003&orientation=landscape",
    level: "高风险",
  },
  {
    id: "case-004",
    size: "small",
    category: "品牌解约",
    brand: "某服饰品牌",
    title: "切割节奏观察",
    summary: "物料下线的先后顺序，往往比声明本身更能反映品牌的态度。",
    metrics: [{ label: "物料下线", value: "9 处" }],
    image:
      "https://readdy.ai/api/search-image?query=editorial%20concept%20of%20removed%20brand%20posters%20and%20empty%20storefront%20lightbox%20on%20a%20cream%20wall%2C%20deep%20crimson%20and%20warm%20amber%20tones%2C%20minimal%20studio%20light%2C%20abstract%20clean%20composition%2C%20high%20detail&width=760&height=560&seq=case-sm-004&orientation=landscape",
    level: "中风险",
  },
  {
    id: "case-005",
    size: "small",
    category: "商业价值",
    brand: "某食品品牌",
    title: "商业价值影响估算",
    summary: "从搜索指数、带货转化到经销商信心，量化代言波动的传导链路。",
    metrics: [{ label: "转化下滑", value: "-18%" }],
    image:
      "https://readdy.ai/api/search-image?query=editorial%20concept%20of%20falling%20sales%20chart%20printed%20on%20a%20cream%20report%20sheet%20with%20a%20pen%2C%20deep%20crimson%20and%20warm%20amber%20tones%2C%20minimal%20studio%20lighting%2C%20abstract%20clean%20composition%2C%20high%20detail&width=760&height=560&seq=case-sm-005&orientation=landscape",
    level: "关注",
  },
  {
    id: "case-006",
    size: "small",
    category: "舆情预警",
    brand: "某数码品牌",
    title: "提前量从哪来",
    summary: "把零散的网友讨论、客服咨询与经销反馈，拼成一张预警地图。",
    metrics: [{ label: "预警命中", value: "7 / 9" }],
    image:
      "https://readdy.ai/api/search-image?query=editorial%20concept%20of%20a%20sentiment%20monitoring%20dashboard%20on%20cream%20paper%20with%20abstract%20node%20map%2C%20deep%20crimson%20and%20warm%20amber%20accents%2C%20minimal%20studio%20light%2C%20abstract%20geometric%20layout%2C%20high%20detail&width=760&height=560&seq=case-sm-006&orientation=landscape",
    level: "关注",
  },
];

export interface TerminationEvent {
  date: string;
  brand: string;
  action: string;
  detail: string;
  stage: "已解约" | "暂停合作" | "观察中";
}

export const terminationEvents: TerminationEvent[] = [
  {
    date: "09-11",
    brand: "某运动品牌",
    action: "撤下全部联名物料",
    detail: "线上旗舰店与线下门店同步下架，官方未发布单独说明。",
    stage: "暂停合作",
  },
  {
    date: "09-09",
    brand: "某饮品集团",
    action: "合约到期不再续约",
    detail: "双方以「合约期满」口径结束合作，物料在两周内完成清理。",
    stage: "已解约",
  },
  {
    date: "09-06",
    brand: "某美妆集团",
    action: "代言人矩阵调整",
    detail: "同一集团下两个子品牌同步调整物料，保留一条产品线合作。",
    stage: "观察中",
  },
  {
    date: "09-03",
    brand: "某服饰品牌",
    action: "官宣延后",
    detail: "原定上线的秋冬系列合作，推迟至舆情回落后再评估。",
    stage: "暂停合作",
  },
  {
    date: "08-30",
    brand: "某数码品牌",
    action: "低调切割",
    detail: "官网代言专区下线，社媒历史内容保留但停止更新联动。",
    stage: "已解约",
  },
];

export const crisisTrend = [
  { day: "09-05", heat: 32, value: 78 },
  { day: "09-06", heat: 45, value: 74 },
  { day: "09-07", heat: 61, value: 69 },
  { day: "09-08", heat: 55, value: 71 },
  { day: "09-09", heat: 78, value: 63 },
  { day: "09-10", heat: 92, value: 57 },
  { day: "09-11", heat: 84, value: 54 },
  { day: "09-12", heat: 72, value: 52 },
];

export const valueImpactMetrics = [
  { label: "代言相关话题量", value: "48.6", unit: "万", delta: "+23%" },
  { label: "品牌侧负面提及", value: "3.1", unit: "万", delta: "+41%" },
  { label: "平均商业价值折损", value: "12.7", unit: "%", delta: "+3.2pt" },
  { label: "舆情平均平息周期", value: "9.4", unit: "天", delta: "-1.1" },
];

export const monitorSteps = [
  {
    step: "01",
    title: "线索汇聚",
    desc: "把社媒讨论、客服反馈、经销动态与公开通报，统一收拢到同一张观察表。",
  },
  {
    step: "02",
    title: "风险定级",
    desc: "按话题性质、扩散速度与关联度，给出高 / 中 / 关注三档判定，避免一刀切。",
  },
  {
    step: "03",
    title: "合作映射",
    desc: "把风险线索回连到具体的代言、联名与商务合作，看清影响的是哪一条业务线。",
  },
  {
    step: "04",
    title: "预警推送",
    desc: "在官宣、续约、物料上线等关键节点前发出提醒，给决策留出提前量。",
  },
];

export const footerColumns = [
  {
    title: "监控方向",
    links: ["代言风险排查", "合作避雷参考", "品牌解约动态", "公关危机跟踪", "商业价值影响"],
  },
  {
    title: "常用维度",
    links: ["风险指数", "热度榜单", "案例速报", "解约时间线", "舆情走势"],
  },
  {
    title: "关于本站",
    links: ["监控方法论", "数据说明", "免责声明", "使用须知", "反馈建议"],
  },
];